module.exports = __webpack_public_path__ + "img/cover-turkiye-is-bankasi-tilt-machine.3af084f1.jpg";